import React,{useEffect} from "react";
import useAiFeatures,{aiHref} from "./useAiFeatures";
export default function AiRoute({feature}){
  const access=useAiFeatures();
  const route=["contracts","compliance","insights","assistant"].includes(feature)?feature:null;
  const allowed=access.enabled&&(feature==="assistant"||access.agent_workspace);
  const destination=route&&aiHref(route);
  useEffect(()=>{if(access.status==="ready"&&allowed&&destination)window.location.replace(destination);},[access.status,allowed,destination]);
  if(access.status==="loading")return <main aria-busy="true"><p role="status">Checking your AI access…</p></main>;
  if(access.status==="error")return <main><h1>Workspace unavailable</h1><p role="alert">We could not check access. Please retry.</p><button onClick={()=>window.location.reload()}>Retry</button></main>;
  if(!allowed)return <main><h1>No access</h1><p>Ask your Stratic administrator to review your AI role.</p><a href="/">Return to SAM</a></main>;
  if(!destination)return <main><h1>Workspace not connected</h1><p>Your AI workspace address has not been configured.</p><a href="/">Return to SAM</a></main>;
  return <main><p role="status">Opening workspace…</p><a href={destination}>Continue</a></main>;
}
